import { formatMoney } from "modules/common/components/money/Money";
import React from "react";
import styles from "./SpendingWarning.module.scss";

export const spendingWarningStyles = styles;

/** Класс раздела: красная полоса — мешает завершить проект, оранжевая — оплачено не всё */
export const spendingSectionClass = (warning: string, unpaid: number) =>
    warning ? styles.object : unpaid > 0 ? styles.objectUnpaid : "";

export { unpaidNotAccepted } from "../validation";

interface SpendingWarningMarkProps {
    /** проблемы, из-за которых проект не перевести в Завершение/Завершено, по строке на исполнителя */
    warning: string;
    /** сколько не оплачено по договорам раздела с непринятой работой (см. unpaidNotAccepted) */
    unpaid: number;
    /** отметка в шапке блока: стоит поверх отступа шапки, а не в строке */
    header?: boolean;
}

/** Отметки раздела: число проблем (красная) и неоплаченный остаток (оранжевая), подробности — в подсказке */
export const SpendingWarningMark = ({ warning, unpaid, header }: SpendingWarningMarkProps) => {
    const stop = (e: React.MouseEvent) => e.stopPropagation();

    // место под отметки есть у каждой строки, даже без них: иначе названия разделов стоят вразнобой
    return (
        <span className={`${styles.marks} ${header ? styles.headerMarks : ""}`}>
            {warning && (
                <span className={styles.mark} title={warning} onClick={stop}>
                    {warning.split("\n").length}
                </span>
            )}
            {unpaid > 0 && (
                <span
                    className={`${styles.mark} ${styles.markUnpaid}`}
                    title={
                        (header
                            ? `Есть разделы с неоплаченными платежами (${formatMoney(unpaid)}), но задания там ещё не приняты.\n`
                            : `Есть неоплаченный платёж (${formatMoney(unpaid)}), но задание ещё не принято.\n`) +
                        "Перевести проект в Завершено это не мешает"
                    }
                    onClick={stop}
                >
                    ₽
                </span>
            )}
        </span>
    );
};
